function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M51.449,48.952H9.338c-2.048,0-3.714-1.666-3.714-3.714V16.584c0-2.048,1.667-3.714,3.714-3.714h42.111   c2.048,0,3.713,1.666,3.713,3.714v28.654C55.162,47.286,53.497,48.952,51.449,48.952z M9.338,15.07   c-0.835,0-1.514,0.679-1.514,1.514v28.654c0,0.835,0.679,1.515,1.514,1.515h42.111c0.834,0,1.514-0.68,1.514-1.515V16.584   c0-0.834-0.68-1.514-1.514-1.514H9.338z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  height: 22.381,
  width: 2.2,
  x: 12.093,
  y: 19.72
}));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  height: 22.381,
  width: 2.2,
  x: 16.818,
  y: 19.72
}));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  height: 22.381,
  width: 2.2,
  x: 21.465,
  y: 19.72
}));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  height: 22.381,
  width: 2.2,
  x: 24.826,
  y: 19.72
}));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  height: 22.381,
  width: 2.199,
  x: 31.091,
  y: 19.72
}));

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  height: 22.381,
  width: 2.199,
  x: 33.735,
  y: 19.72
}));

var _ref9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  height: 22.381,
  width: 2.199,
  x: 38.074,
  y: 19.72
}));

var _ref10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  height: 22.381,
  width: 2.199,
  x: 43.208,
  y: 19.72
}));

var _ref11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  height: 22.381,
  width: 2.199,
  x: 47.213,
  y: 19.72
}));

var SvgBarcode = function SvgBarcode(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 60 60",
    height: "60px",
    id: "Layer_1",
    viewBox: "0 0 60 60",
    width: "60px",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBarcode, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/barcode.e3196210.svg";
export { ForwardRef as ReactComponent };